<template>
	
	<div class="multiselect-button" v-click-outside="close">
    <div class="selected-display" :class="{ 'is-open': open, 'is-large': isLarge, 'has-text-weight-bold': isBold }" @click="toggle()" tabindex="0">
    {{label}}
		</div>
		<div class="options" :class="{ 'is-open': open }">
			<div class="option" v-for="option in options" :class="{ 'is-selected': isSelected(option.value) }" @click="select(option)">
				<span class="option-label">{{option.label}}</span>
				<span class="checkmark" v-if="isSelected(option.value)">
					<i class="fas fa-check"></i>
				</span>
			</div>
		</div>
	</div>
	
</template>

<script>
	import vClickOutside from "v-click-outside";
	import Pluralize from "pluralize";
	
	export default {
        name: "MultiselectButton",
        
        directives: {
        	clickOutside: vClickOutside.directive,
        },
        
        props: {
			name: { default: null },
			value: { type: Array, default: function () { return [] } },
			options: { type: Array, default: function () { return [] } },
			prefix: { default: null },
			multiselect: { default: true },
			isLarge: { default: false },
			isBold: { default: false }
        },
        
        data() {
            return {
            	open: false
            };
        },

        methods: {
        	toggle() {
        		this.open = !this.open;
        	},
        	
        	close() {
        		this.open = false;
        	},
        	
        	select(option) {
        		let selection = option.value;
        		let newValues = null;
        		let idx = this.value.indexOf(selection);
        		
        		if(this.multiselect) {
	        		// See if it's already selected
	        		
	        		newValues = [...this.value];
	        		
	        		if(idx != -1) {
	        			// Already selected, unselect it
	        			newValues.splice(idx, 1);
	        		} else {
	        			// Select it
	        			newValues.push(selection);
	        		}
        		} else {
        			// Single select, just replace it
        			newValues = idx != -1 ? [] : [selection];
        		}
        		
        		this.$emit("input", newValues);
        		this.$emit("select-changed");
        		this.close();
        	},
        	
        	isSelected(value) {
        		return this.value.indexOf(value) != -1;
        	}
        },
        
        computed: {
        	label() {
        		let label = "";
        		let totalSelected = this.value.length;
        		
        		if(totalSelected == 0) {
        			label = this.prefix ? this.prefix : "Any " + this.name;
        		} else if(this.name) {
        			label = "+" + Pluralize(this.name, totalSelected, true);
        		} else if(this.prefix && !this.multiselect) {
        			var selectedLabel = this.options.find(option => {
       				  return option.value === this.value[0];
       				}).label;
       				
        			label = this.prefix + " " + selectedLabel;
        		}
        		
        		return label;
        	}
        }
        
    };
</script>